import { Route } from '@angular/router';
import { HREF } from '@core';
import { CheckoutPageComponent } from './pages/checkout-page/checkout-page.component';
import { CheckoutContainerComponent } from './components/checkout-container/checkout-container.component';
import { CheckoutConfirmationPageComponent } from './pages/checkout-confirmation-page/checkout-confirmation-page.component';
import { checkoutGuard } from './checkout.guard';

export const CHECKOUT_ROUTES_BRANCH: Route = {
  path: HREF.CHECKOUT,
  component: CheckoutContainerComponent,
  children: [
    {
      path: '',
      component: CheckoutPageComponent,
      canActivate: [checkoutGuard],
    },
    {
      path: HREF.CHECKOUT_CONFIRMATION,
      component: CheckoutConfirmationPageComponent,
    },
  ],
};
